import numbers from 'cldr-data/main/es/numbers.json';
import dateFields from 'cldr-data/main/es/dateFields.json';
import units from 'cldr-data/main/es/units.json';
import currencies from 'cldr-data/main/es/currencies.json';
import caGregorian from 'cldr-data/main/es/ca-gregorian.json';
import timeZoneNames from 'cldr-data/main/es/timeZoneNames.json';

export default [
  numbers,
  dateFields,
  units,
  currencies,
  caGregorian,
  timeZoneNames,
];



// WEBPACK FOOTER //
// ./src/application/globalize/cldr/es.js